import { render, staticRenderFns } from "./DefaultForm.vue?vue&type=template&id=ca00a0b2"
import script from "./DefaultForm.vue?vue&type=script&lang=js"
export * from "./DefaultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports